import axios from "axios";
import { BASE_URL } from "../constants/APIConstants";

/** Axios config carrying the admin auth headers expected by the API. */
export function authConfig() {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      source: "administer",
    },
  };
}

export function logApiError(error) {
  const status = error.response?.status;
  if (status === 400) {
    console.log("Bad Request Error: ", error.response.data);
  } else if (status === 403) {
    console.log("Forbidden Error: ", error.response.data);
  } else {
    console.log("Error: ", error);
  }
}

const identity = (data) => data;

/**
 * Request on `BASE_URL + path`, authenticated unless `auth` is false.
 * Resolves with `select(response.data)`. On any failure (network, HTTP or a
 * throwing `select`) the error is logged, then rethrown if `rethrow` is set,
 * otherwise the promise resolves with `fallback`.
 */
export function apiRequest(
  method,
  path,
  { data, select = identity, fallback, rethrow = false, auth = true } = {}
) {
  const url = `${BASE_URL}${path}`;
  const config = auth ? authConfig() : undefined;
  const request =
    method === "get" || method === "delete"
      ? axios[method](url, config)
      : axios[method](url, data, config);

  return request
    .then((response) => select(response.data))
    .catch((error) => {
      logApiError(error);
      if (rethrow) throw error;
      return fallback;
    });
}

/** GET resolving with `select(data)`, or `fallback` on failure. */
export function getResource(path, options) {
  return apiRequest("get", path, options);
}

/** Same as `getResource` for read-only endpoints that expect a POST body. */
export function postQuery(path, body, options) {
  return apiRequest("post", path, { ...options, data: body });
}

/** Write resolving with `true` on success and `false` on failure. */
export function sendForSuccess(method, path, data) {
  return apiRequest(method, path, {
    data,
    select: () => true,
    fallback: false,
  });
}

/** DELETE resolving with the response body; rethrows on failure. */
export function deleteResource(path) {
  return apiRequest("delete", path, { rethrow: true });
}
